import React, { useState } from "react";
import "./CodePromo.scss";
import WarningIcon from "../../../images/WarningIcon.svg";
import { languageData } from "../../../i18n";
import { CodePromoSuggestion } from "../../../interfaces/loyality.interface";

/**
 * CodePromo component description.
 *
 * @CodePromo
 *
 */

interface CodePromoProps {
  codePromoSuggestion: CodePromoSuggestion | undefined;
  promoCode: string;
  promoCodeError: string;
  isDisabled: boolean;
  isPromoCodeApplied: boolean;
  showError: boolean;
  setPromoCode: (promoCode: string) => void;
  onSubmit: () => void;
}

const CodePromo: React.FC<CodePromoProps> = ({
  codePromoSuggestion,
  promoCode,
  promoCodeError,
  isDisabled,
  isPromoCodeApplied,
  showError,
  setPromoCode,
  onSubmit,
}) => {
  const { errorMessages } = languageData.fr;

  const minPanierMessage = codePromoSuggestion?.cartThreshold
    ? `Pour bénéficier d'une réduction de ${codePromoSuggestion.discountValue}% , votre panier doit atteindre un montant minimum de ${codePromoSuggestion.cartThreshold} €.`
    : "";

  return (
    <div className="CodePromo">
      <div className={`block-wrapper ${isDisabled ? "disabled-field" : ""}`}>
        <div className="header-code">
          <p>Coupon code</p>
        </div>
        <div className={`promo-container ${promoCode ? "active-field" : ""}`}>
          <input
            type="text"
            value={promoCode}
            onChange={(e) => setPromoCode(e.target.value)}
            disabled={isDisabled}
            placeholder="Saisissez un code promo"
          />

          <button disabled={isDisabled} onClick={onSubmit}>
            {isPromoCodeApplied ? "Annuler" : "Appliquer"}
          </button>
        </div>
        {minPanierMessage && (
          <p className="min-panier-message">{minPanierMessage}</p>
        )}
        {promoCodeError && (
          <p className="error-message">
            {promoCode.length === 0
              ? "Veuillez saisir un code promo."
              : errorMessages[promoCodeError as keyof typeof errorMessages]}
          </p>
        )}
        {isDisabled && (
          <div className="disabled-msg">
            <img src={WarningIcon} alt="" />
            <span>Une seule offre possible : remise ou code promo.</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default CodePromo;
